export default "__VITE_ASSET__C90k2XxJ__"